import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Box,
  IconButton,
  Divider
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const Cart = () => {
  const { user } = useAuth();
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchCart();
    }
  }, [user]);

  const fetchCart = async () => {
    try {
      setLoading(true);
      // Ici on appellerait cartService.getCart(user.id)
      // Pour l'instant, on simule un panier vide
      setCart({ items: [] });
    } catch (error) {
      console.error('Error fetching cart:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Container><Typography>Chargement...</Typography></Container>;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Mon Panier
      </Typography>

      {cart?.items?.length === 0 ? (
        <Card>
          <CardContent>
            <Typography variant="h6" align="center">
              Votre panier est vide
            </Typography>
            <Box textAlign="center" sx={{ mt: 2 }}>
              <Button variant="contained" href="/products">
                Continuer mes achats
              </Button>
            </Box>
          </CardContent>
        </Card>
      ) : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            {/* Liste des articles du panier */}
            <Typography variant="h6">Articles dans votre panier</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Résumé de la commande
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between">
                  <Typography>Sous-total:</Typography>
                  <Typography>0€</Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Typography>Livraison:</Typography>
                  <Typography>Gratuite</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="h6">Total:</Typography>
                  <Typography variant="h6">0€</Typography>
                </Box>
                <Button variant="contained" fullWidth sx={{ mt: 2 }}>
                  Passer la commande
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default Cart;
